import axios from "axios";
import { apiAxiomLog } from "./logging";

export const apiGetVersions = async (topic) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/versions?action=${topic}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { docVersions } = response.data;
          return docVersions;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetAssignments");
    console.log(error);
    return [];
  }
};

export const apiGetTopicMotions = async (topic) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/motions/${topic}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api topics getTopicMotions");
    console.error(error);
    return null;
  }
};

export const apiUpdateVersions = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .put(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/versions`,
        {
          data,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return false;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiUpdateVersions");
    console.log(error);
    return [];
  }
};

export const apiRestoreVersion = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/versions`,
        {
          data,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return false;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiUpdateVersions");
    console.log(error);
    return [];
  }
};

export const apiDeleteVersion = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/remove-ver`,
        {
          data,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return false;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiDeleteVersion");
    console.log(error);
    return [];
  }
};

export const apiCreateCopy = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/copy`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    return null;
  }
};

export const apiMoveGroup = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/movegroup`,
        {
          ...data,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiMoveGroup");
    console.log(error);
    return null;
  }
};

export const apiUpdateTopic = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/update/${id}`,
        {
          ...data,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiUpdateTopic");
    console.log(error);
    return null;
  }
};

export const apiGetBulkTopics = async (session, group) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/consent/${session}?group=${group}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetBulkTopics");
    console.log(error);
    return null;
  }
};

export const apiGetDetails = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(`${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/doc/${id}`, config)
      .then(function (response) {
        if (response.status === 200) {
          const { doc } = response.data;
          return doc;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetDetails");
    console.log(error);
    return null;
  }
};

export const apiExportPdf = async (topic) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/pdf/action/${topic}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetAssignments");
    console.log(error);
    return null;
  }
};

export const apiPreviewPdf = async (topic) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/pdf/preview/${topic}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetAssignments");
    console.log(error);
    return null;
  }
};

export const apiUpdateVotedOn = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/voted-on/${id}`,
        {
          ...data,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiUpdateVotedOn");
    console.log(error);
    return null;
  }
};

export const apiGetTopicPrint = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/print/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetDetails");
    console.log(error);
    return null;
  }
};

export const apiGetTopicPrintClean = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/print-clean/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetDetails");
    console.log(error);
    return null;
  }
};

export const apiGetTopicBoard = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/boardportal/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetDetails");
    console.log(error);
    return null;
  }
};

export const apiCreateTopic = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/new`,
        {
          ...data,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiCreateTopic");
    console.log(error);
    return null;
  }
};

export const apiGetActionsList = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/list/${client}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return [];
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetActionsList");
    console.log(error);
    return [];
  }
};

export const apiGetGroupActions = async (session, group) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/group/${session}?group=${group}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return [];
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetGroupActions");
    console.log(error);
    return [];
  }
};

export const apiGetActionsFiltered = async (client, filters) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/list/${client}`,
        { ...filters },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return [];
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetActionsFiltered");
    console.log(error);
    return [];
  }
};

export const apiGetActionsSearch = async (client, filters) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/search/${client}`,
        { ...filters },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return [];
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetActionsSearch");
    console.log(error);
    return [];
  }
};

export const apiGetActionsSearchText = async (client, filters) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/search-text/${client}`,
        { ...filters },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return [];
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetActionsSearch");
    console.log(error);
    return [];
  }
};

export const apiGetSingleAction = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/overview/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetSingleAction");
    console.log(error);
    return null;
  }
};

export const apiDeleteSingleAction = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .delete(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/doc/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiDeleteSingleAction");
    console.log(error);
    return null;
  }
};

export const apiGetPrivateNotes = async (id, user) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/notes/${id}?user=${user}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    apiAxiomLog({
      stack: "frontEnd",
      function: "lib/api/topics apiGetPrivateNotes",
      params: { id, user },
      error: error.toString(),
    });
    return null;
  }
};

export const apiMoveToMeeting = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/move-meeting`,
        {
          ...data,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    apiAxiomLog({
      stack: "frontEnd",
      function: "lib/api/topics apiMoveToMeeting",
      params: data,
      error: error.toString(),
    });
    return null;
  }
};

export const apiImportTopicsfromUrl = async (url, client, board) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_IMPORT_URL}/api/v3/scrape`,
        {
          url,
          entity: client,
          board,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiImportTopicsfromUrl");
    console.log(error);
    return null;
  }
};

export const apiGetDuplicateData = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/duplicate`,
        {
          ...data,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetDuplciateData");
    console.log(error);
    return null;
  }
};

export const apiGetLiveNotes = async (id, groupTopic, session) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/live-notes/${id}?groupTopic=${groupTopic}&session=${session}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiGetLiveNotes");
    console.log(error);
    return null;
  }
};

export const apiUpdateLiveNotes = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/live-notes/${id}`,
        {
          ...data,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiUpdateLiveNotes");
    console.log(error);
    return null;
  }
};

export const apiReOrderTopics = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/reorder`,
        {
          ...data,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return false;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiUpdateVersions");
    console.log(error);
    return [];
  }
};

export const apiGetTopicProperties = async (topic, client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/properties/${topic}?client=${client}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api topics apiGetTopicProperties");
    console.error(error);
    return null;
  }
};

export const apiGetBulkTopic = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/bulktopic`,
        {
          ...data,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api topics apiGetBulkTopic");
    console.error(error);
    return null;
  }
};

export const apiUpdateDetailsVariables = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/variables`,
        {
          ...data,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api topics apiUpdateDetailsVariables");
    console.log(error);
    return null;
  }
};

export const apiGetPlayByPlay = async (topic) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/pbp/${topic}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api topics apiGetPlayByPlay");
    console.error(error);
    return null;
  }
};

export const apiGetGroupPlayByPlay = async (meeting, group) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/group-pbp/${meeting}?group=${group}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.error("error api topics apiGetGroupPlayByPlay");
    console.error(error);
    return null;
  }
};
